// extracted by mini-css-extract-plugin
export var csatScore = "_iw-5";
export var header = "_iw-1";
export var panelWrapper = "_iw-2";
export var postPreview = "_iw-3";
export var rightContent = "_iw-0";
export var wrappingText = "_iw-4";